module.exports = __webpack_public_path__ + "img/nofilter.6585c0fa.svg";